export const wechselrichter = {
    WechselrichterClass: {
        url: "Wechselrichter",
        defaultSegment: "Wechselrichter",
        forceRefresh: false,
        receiveType: 'RECEIVE_WechselrichterClass_wechselrichterReducer'
    }
};